<template>
    <div class="rd-card rd-card--border-top calculator__card" v-if="!hasError && quoteAsArrayToRender">
        <div class="calculator__card-header">
            <h2 class="calculator__card-title">{{ financeName }}</h2>
            <p class="calculator__card-price">{{ monthlyPaymentFormatted }} <span class="calculator__card-price-months">x {{ numberOfPayments }} months</span></p>
        </div>

        <div class="calculator__card-body" v-if="quoteAsArrayToRender">
            <div class="calculator__card-item" v-for="(item, index) in quoteAsArrayToRender" :key="index">
                <span class="calculator__card-item-label" v-html="item.title"></span>
                <span class="calculator__card-item-value" v-html="item.value"></span>
            </div>
        </div>

        <div class="calculator__card-cta">
            <button type="button" @click="openApplyForFinanceModal" class="btn btn--finance-inverted calculator__card-secondary-cta">Apply for finance</button>
            <button type="button" @click="openFreeCreditCheckModal" class="btn btn--finance calculator__card-primary-cta">Free Credit Check</button>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import NumberFormat from "../../used-vue/api/NumberFormat.js";
import getFinanceNameFromKey from '../../used-vue/api/finance/GetFinanceNameFromKey.js';
import { customEvent } from '../../modules/tracking/AnalyticsEvents';

export default {
    props: {
        financeKey: {
            type: String,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {
        ...mapState(['selectedNewVehicle']),

        financeName() {
            if (this.financeKey == 'PCP') {
                return this.$store.state.Finance.pcpQuote.name;
            }

            if (this.financeKey == 'HP') {
                return this.$store.state.Finance.hpQuote.name;
            }

            return getFinanceNameFromKey({
                brand: this.selectedNewVehicle.brand,
                manufacturer: this.selectedNewVehicle.manufacturer,
            }, this.financeKey, false);
        },


        hasError() {
            if (this.financeKey == 'PCP') {
                if (this.$store.state.Finance.pcpQuote == null) {
                    return true;
                }
                return false;
            } else if (this.financeKey == 'HP') {
                if (this.$store.state.Finance.hpQuote == null) {
                    return true;
                }
                return false;
            }
            return true;
        },

        numberOfPayments() {
            if (this.hasError) {
                return null;
            }

            if (this.financeKey == 'PCP') {
                return this.$store.state.Finance.pcpQuote.numberOfPayments;
            }

            if (this.financeKey == 'HP') {
                return this.$store.state.Finance.hpQuote.numberOfPayments;
            }

            return null;
        },

        monthlyPayment() {
            if (this.hasError) {
                return null;
            }

            if (this.financeKey == 'PCP') {
                return this.$store.state.Finance.pcpQuote.monthlyPayment;
            }

            if (this.financeKey == 'HP') {
                return this.$store.state.Finance.hpQuote.monthlyPayment;
            }

            return null;
        },

        monthlyPaymentFormatted() {
            if (this.hasError) {
                return null;
            }
            return '£' + NumberFormat(this.monthlyPayment);
        },

        quoteAsArrayToRender() {
            if (this.hasError) {
                return null;
            }

            if (this.financeKey == 'PCP') {
                return this.$store.state.Finance.pcpQuote.quote;
            }

            if (this.financeKey == 'HP') {
                return this.$store.state.Finance.hpQuote.quote;
            }

            return [];
        }
    },
    methods: {
        openApplyForFinanceModal() {
            customEvent("Configurator Final Screen", "Apply For Finance", "Clicked");
            this.$emit('apply-for-finance', {
                key: this.financeKey,
                type: 'Apply'
            });
        },
        openFreeCreditCheckModal() {
            customEvent("Configurator Final Screen", "Free Credit Check", "Clicked");
            this.$emit('apply-for-finance', {
                key: this.financeKey,
                type: 'MotorCreditCheck'
            });
        },
    },
};
</script>

<style scoped lang="scss">
.calculator {
    &__card {
        display: flex;
        flex-direction: column;
        gap: 30px;
    }

    &__card-title {
        font-size: 18px;
        font-weight: 700;
        color: #0b1e3a;
    }

    &__card-price {
        margin: 3px 0 0 0;
        font-size: 22px;
        font-weight: 700;
        color: #00a3e0;

    }
    &__card-price-months {
        font-size: 16px;
        color: #0b1e3a;
        font-weight: 400;
    }

    &__card-item {
        display: flex;
        justify-content: space-between;
        padding-bottom: 8px;
    }

    &__card-item-label {
        font-size: 16px;
        color: #0b1e3a;
        font-weight: 400;
    }

    &__card-item-value {
        font-size: 16px;
        font-weight: 700;
        color: #00a3e0;
        text-align: right;
    }

    &__card-body {
        flex-grow: 1;
        flex-shrink: 1;
    }

    &__card-cta {
        display: flex;
        flex-direction: column;
        gap: 15px;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/configurator/components/FinanceQuote.vue